var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import linker from '../linker';
import showError from '../central/showError';
import { EventNaviItem } from './molecules';
import { DropPop, GridLayout } from './atoms';
import { EventService } from '../services/EventService';
import { TermNaviService } from '../services/TermNaviService';
import { BaseService } from '../services/BaseService';
var EventNavi = (function (_super) {
    __extends(EventNavi, _super);
    function EventNavi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.category = null;
        _this.events = [];
        _this.contentClass = 'rsp2Grid';
        _this.sortByItems = BaseService.getDropPopItems('eventNavi').concat();
        _this.sort = _this.sortByItems.find(function (item) { return item.selected; }).value;
        return _this;
    }
    EventNavi.prototype.mounted = function () {
        this.load();
    };
    EventNavi.prototype.load = function () {
        var _this = this;
        if (SP.Guid.isValid(this.termSetId)) {
            if (!this.showAll) {
                var srv = TermNaviService.start(this.termSetId);
                var termPath = srv.getCurrentTermPath();
                srv.loadTermItem(termPath).then(function (term) {
                    if (term) {
                        _this.category = term;
                        _this.ensureEvents();
                    }
                });
            }
            else {
                this.ensureEvents();
            }
        }
        else {
            showError('CategoryNaviTermSetId in Portalkonfiguration ist nicht gesetzt!');
        }
    };
    EventNavi.prototype.setSort = function (sort) {
        this.sort = sort;
        this.ensureEvents();
    };
    EventNavi.prototype.ensureEvents = function () {
        var _this = this;
        if (this.showAll) {
            new EventService().loadAllEvents(this.sort).then(function (events) {
                _this.events = events;
            });
        }
        else {
            new EventService().loadEvents(this.category, this.sort).then(function (events) {
                _this.events = events;
            });
        }
    };
    __decorate([
        Prop({ type: String })
    ], EventNavi.prototype, "termSetId", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], EventNavi.prototype, "showAll", void 0);
    EventNavi = __decorate([
        Component({
            components: {
                GridLayout: GridLayout,
                DropPop: DropPop,
                EventNaviItem: EventNaviItem,
            },
        })
    ], EventNavi);
    return EventNavi;
}(Vue));
export default EventNavi;
linker.register('eventNavi', EventNavi);
